import { FormControl, FormHelperText, Box, Typography } from "@mui/material"
import BaseCheckbox from "components/base/Checkbox"
import useCheckbox from "hooks/use_checkbox"
import useTranslation from "../../../hooks/use_translation"

const PrivacyData = () => {
  const id = "privacy_data"

  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === false) return fields?.privacy_policy_error_not_agreed

    return ""
  }

  const { handleChange, inputValue, errorMessage } = useCheckbox(id, validate)

  const CheckboxLabel = () => (
    <Typography variant="body2" sx={{ mt: 0.5 }}>
      {fields?.privacy_policy_title}
    </Typography>
  )

  return (
    <FormControl error={errorMessage?.length > 0}>
      <Box sx={{ display: "flex", alignItems: "flex-start", mt: 0.5 }}>
        <BaseCheckbox checked={inputValue} onChange={handleChange} />
        <CheckboxLabel />
      </Box>
      <FormHelperText sx={{ ml: 5 }}>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default PrivacyData
